/**
 * Google Tag Manager + Consent Mode v2. Il container GTM (tutti i tag —
 * GA4, Meta Pixel, Google Ads — configurati là dentro, non qui) si carica
 * SEMPRE, indipendentemente dal consenso: è il pattern ufficiale Google, non
 * una falla. Il container in sé non traccia nulla da solo — sono i singoli
 * tag al suo interno a farlo, e ognuno rispetta i segnali di consenso qui
 * sotto (i tag Google nativamente, gli altri — es. Meta Pixel — tramite le
 * "Consent Settings" configurate sul tag in GTM). Bloccare l'intero
 * container impedirebbe a Google di modellare i dati mancati quando l'utente
 * rifiuta, che è uno dei vantaggi di Consent Mode.
 */

function pushDataLayer(args) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(args);
}

function gtag() {
  pushDataLayer(arguments);
}

function mapConsent(consent) {
  return {
    analytics_storage: consent.statistics ? 'granted' : 'denied',
    ad_storage: consent.marketing ? 'granted' : 'denied',
    ad_user_data: consent.marketing ? 'granted' : 'denied',
    ad_personalization: consent.marketing ? 'granted' : 'denied',
  };
}

/** Va chiamato una sola volta, prima di caricare il container — imposta il default più prudente (tutto negato). */
export function setDefaultConsent() {
  gtag('consent', 'default', {
    analytics_storage: 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
  });
}

/** Da richiamare a ogni cambio di preferenze (vedi GoogleTagManager.jsx, in ascolto su useConsent()). */
export function updateConsent(consent) {
  gtag('consent', 'update', mapConsent(consent));
}

let loaded = false;

/** Inietta lo script loader di GTM (snippet ufficiale). Idempotente — sicuro da richiamare più volte. */
export function loadGTM(containerId) {
  if (loaded || !containerId) return;
  loaded = true;
  gtag('js', new Date());
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://www.googletagmanager.com/gtm.js?id=' + containerId;
  document.head.appendChild(script);
  // Niente <noscript><iframe> di fallback: il sito è una SPA React puramente
  // client-side, senza JS non renderizza comunque nulla — il fallback GTM
  // per utenti senza JS non avrebbe alcun effetto qui.
}
